import { render } from "./calendarDaysInMonth.vue?vue&type=template&id=964d94a4&scoped=true"
import script from "./calendarDaysInMonth.vue?vue&type=script&lang=js"
export * from "./calendarDaysInMonth.vue?vue&type=script&lang=js"

import "./calendarDaysInMonth.vue?vue&type=style&index=0&id=964d94a4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-964d94a4"

export default script